import {
  linkGradientConfigA52,
  TOURNEY_FINISH_DISTRIBUTION_PROP_LBL_MAP,
} from "@/src/constants/StatsCornerConstants";
import styles from "../Stats.module.css";
import { SankeyCharts } from "@/src/components/CommonCharts/SankyCharts";
export const TourneyFinishDistribution = ({ tourneyFinishDistribution }) => {
  if (
    !tourneyFinishDistribution ||
    Object.keys(tourneyFinishDistribution).length === 0
  )
    return null;
  return (
    <>
      <div className="section-title font-medium text-secondary mt-[16px]">
        Tournaments Finish Distribution
      </div>
      <div
        className={`flex flex-col ${styles.coreCardConfigBkNoBorder} p-3 mt-3`}
      >
        <SankeyCharts
          distributionObj={tourneyFinishDistribution}
          coreMap={TOURNEY_FINISH_DISTRIBUTION_PROP_LBL_MAP}
          sourcePropNm="Played"
          width={328}
          height={224}
          gradientConfig={linkGradientConfigA52}
          gradientId="tourney-link-sankey"
          linkColor=""
        />
      </div>
    </>
  );
};
